import { useState } from 'react';
import { Container, ImageStyle, Images, TextGrid, ContentGrid, IconStyle } from './styles';
import { CountDamageType } from '../../types';
import AlertIcon from '@/components/Alert/AlertIcon';

interface VehicleImageProps {
  data: CountDamageType | File; // data가 CountDamageType 또는 File 타입일 수 있음
  isBeforeImage?: boolean; // beforeImagesToShow 여부를 확인
}

export function VehicleImageData({ data, isBeforeImage }: VehicleImageProps) {
  const legend = ['Scratch', 'Separated', 'Crushed', 'Breakage'];
  const errorIcon = "/assets/favicon/alert.png";
  const errorImage = "/assets/images/result.png";

  // 이미지 처리 로직
  let vehicleImage: string;
  if (isBeforeImage && data instanceof File) {
    vehicleImage = URL.createObjectURL(data); // File 타입의 이미지를 Blob URL로 변환
  } else if (!isBeforeImage && (data as CountDamageType)?.images) {
    vehicleImage = `data:image/jpeg;base64,${(data as CountDamageType).images}`; // CountDamageType 타입의 Base64 이미지 처리
  } else {
    vehicleImage = errorImage; // 기본 에러 이미지
  }

  const isImageError = vehicleImage === errorImage;

  // TextGrid를 보여줄지 여부 결정
  const hasDamage = !isBeforeImage && (
    (data as CountDamageType)?.scratch_num > 0 ||
    (data as CountDamageType)?.separated_num > 0 ||
    (data as CountDamageType)?.crushed_num > 0 ||
    (data as CountDamageType)?.breakage_num > 0
  );

  const [isHovered, setIsHovered] = useState(false);

  return (
    <Container>
      <ImageStyle>
        {isImageError && (
          <IconStyle
            component={() => (
              <img
                src={errorIcon}
                alt="Error"
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  zIndex: 1,
                  cursor: 'pointer',
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              />
            )}
          />
        )}
        {hasDamage && (
          <div onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
            <AlertIcon size={'2vw'} color="#ffffff" backgroundColor="#202020" />
          </div>
        )}
        <Images
          style={{ width: '100%', position: 'relative' }}
          loading='lazy'
          src={vehicleImage}
          alt="Vehicle Image"
          onError={(e) => { e.currentTarget.src = errorImage }} // 이미지 로딩 실패 시 errorImage로 대체
        />
        {/* TextGrid 영역 */}
        {hasDamage && isHovered && (
          <TextGrid
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.7)', // 검은색 투명 배경
            zIndex: 2,
            color: '#fff',
            display: 'flex',
            flexDirection: 'column', // 세로 정렬
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {legend.map((item, index) => {
            const legendData = data as CountDamageType;
            const count = [
              legendData?.scratch_num,
              legendData?.separated_num,
              legendData?.crushed_num,
              legendData?.breakage_num,
            ][index];
        
            // count가 0보다 큰 경우에만 ContentGrid를 출력
            if (count <= 0) return null;
        
            return (
              <ContentGrid key={index}>
                <div>{item}</div>
                <p>{count > 0 ? `${count}개` : '-'}</p>
              </ContentGrid>
            );
          })}
        </TextGrid>        
        )}
      </ImageStyle>
    </Container>
  );
}
